var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 61.2977H7.81079C7.25851 61.2977 6.81079 60.85 6.81079 60.2977V11.7031C6.81079 11.1508 7.25851 10.7031 7.81079 10.7031H25.4515C25.709 10.7031 25.9565 10.8024 26.1426 10.9803L35.2073 19.6476C35.3934 19.8255 35.641 19.9248 35.8984 19.9248H65.1621C65.7144 19.9248 66.1621 20.3725 66.1621 20.9248V32.1085",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.0811,
    cy: 46.2172,
    r: 11.8851,
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8649 54.4863L66.6487 62.2701",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoResult);
export default __webpack_public_path__ + "static/media/icon-no-result.68adc72d0efe8e70a8d94871316d9670.svg";
export { ForwardRef as ReactComponent };